import { render } from "./LongTerm.vue?vue&type=template&id=1f752b9e&scoped=true"
import script from "./LongTerm.vue?vue&type=script&lang=js"
export * from "./LongTerm.vue?vue&type=script&lang=js"

import "./LongTerm.vue?vue&type=style&index=0&id=1f752b9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f752b9e"]])

export default __exports__